exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-automation-section .automation-design-content{margin-top:.5rem}", ""]);

// exports
